import { AxiosInstance, AxiosPromise } from 'axios';
import { fromArrayToCSV } from '@trukt/portal-utils/fromArrayToCSV';
import {
  AttachmentServicesEndpoints,
  AttachmentsSearchRequest,
  AttachmentsSearchResponse,
  AttachmentCreateRequest,
  AttachmentCreateResponse,
  AttachmentDeleteRequest,
  AttachmentDeleteResponse,
} from './AttachmentServices.types';
import type {
  Attachment,
  AttachmentTypesLiterals,
  AttachmentVisibilityLiterals,
} from '@trukt/types/Attachment';
import type { BaseRequest } from '@trukt/types/BaseRequest';

export type AttachmentsRequest = BaseRequest<{
  parent: string;
  parentType: 'jobs' | 'orders' | 'commodities';
  attachmentType?: AttachmentTypesLiterals;
  visibility?: AttachmentVisibilityLiterals[];
}>;
export type AttachmentsResponse = Attachment[];

export class AttachmentServices implements AttachmentServicesEndpoints {
  instance: AxiosInstance;
  constructor(instance: AxiosInstance) {
    this.instance = instance;
  }

  search(request: AttachmentsSearchRequest) {
    return this.instance.get<AttachmentsSearchResponse>('/attachments', {
      params: {
        ...request.queryParams,
        orders: fromArrayToCSV(request.queryParams.orders),
        jobs: fromArrayToCSV(request.queryParams.jobs),
        inspections: fromArrayToCSV(request.queryParams.inspections),
        terminals: fromArrayToCSV(request.queryParams.terminals),
        commodities: fromArrayToCSV(request.queryParams.commodities),
        companies: fromArrayToCSV(request.queryParams.companies),
        acl: fromArrayToCSV(request.queryParams.acl),
      },
    });
  }

  create(request: AttachmentCreateRequest) {
    return this.instance.put<AttachmentCreateResponse>(
      `/attachments/${request.routeParams.fileId}`,
      request.body,
    );
  }

  delete(request: AttachmentDeleteRequest) {
    return this.instance.put<AttachmentDeleteResponse>(
      `/attachments/${request.routeParams.fileId}`,
      request.body,
    );
  }

  update(_request: {}): AxiosPromise<unknown> {
    throw new Error('Method not implemented.');
  }

  getById(_request: {}): AxiosPromise<unknown> {
    throw new Error('Method not implemented.');
  }

  get({ queryParams }: AttachmentsRequest) {
    return this.instance.get<AttachmentsResponse>('/attachments/search', {
      params: queryParams,
    });
  }
}
